import { Pipe, PipeTransform } from '@angular/core';
import { IUser } from '@app/services/user/_models';

@Pipe({
	name: 'initials'
})
export class InitialsPipe implements PipeTransform {
	transform(person: IUser, args?: any): string {
		let initials = '';

		if (person) {
			if (person.firstname) {
				initials += person.firstname.substr(0, 1);
			}
			if (person.lastname) {
				initials += person.lastname.substr(0, 1);
			}
		}

		return initials.toUpperCase();
	}
}
